import alAnsarrBookImg0 from "../assets/al-ansarr-book-niveau-0.png";
import alAnsarrBookImg1 from "../assets/al-ansarr-book-niveau-1.png";
import alAnsarrBookImg2 from "../assets/al-ansarr-book-niveau-2.png";
import alAnsarrBookImg32 from "../assets/al-ansarr-book-niveau-3-2.png";

export const intituteNumber = "+222 41 44 15 72";
export const instituteNumberSister = "+33 6 52 27 41 49";

export const instituteInfo = {
  name: "Al-Ansarr",
  number: intituteNumber,
  instituteNumberSister,
  whatstappLink: `https://wa.me/${intituteNumber}`.replace(/\s+/g, ""),
  gmail: "institutansarr@gmail.com",
  telegramLink: "https://t.me/institu_alAnsarr",
};

export const APP_PATH = {
  HOME: "/",
  ABOUT: "/about-us",
  CONTACT: "/contact-us",
  LOGIN: "/login",
  PROGRAM: "/school-program",
  PRICING: "/pricing",
  REGISTRATION: "/registration",
  RULES: "/institut-rules",
  SUBSCRIBE: "/subscribtion",
  UNKNOWN: "*",
};

export const DEFAULT_BLUE = "#1D3557";
export const DEFAULT_GOLD = "#F8CF40";
export const DEFAULT_RED = "#D32F2F";
export const DEFAULT_BUTTON_STYLE = {
  "&:hover": {
    backgroundColor: DEFAULT_GOLD,
    color: DEFAULT_BLUE,
  },
};

export const carouselItems = [
  {
    image: alAnsarrBookImg0,
    caption: "Niveau Introductif",
  },
  {
    image: alAnsarrBookImg1,
    caption: "Niveau 1",
  },
  {
    image: alAnsarrBookImg2,
    caption: "Niveau 2",
  },
  //   {
  //     image: alAnsarrBookImg3,
  //     caption: "Niveau 3",
  //   },
  {
    image: alAnsarrBookImg32,
    caption: "Niveau 3",
  },
];

export const fontFamily = ["Roboto", "Helvetica", "Arial", "sans-serif"];
